<!-- 통신사 수신함 (연합뉴스)
     기사작성 참고용 목록이다. 여기서 [기사 작성] 을 누르면 /writeArticles?wire=<id> 로
     **새 기사**가 열린다(기존 ?id= 는 수정이라 성격이 다르다).
     서버: /api/wire/*  ·  문서: docs/50-운영/12-통신사-수신함.md -->
<template>
  <div id="wire-list-view" class="data-list-container">

    <vs-table ref="table" :data="list">
      <div slot="header" class="flex flex-wrap items-center flex-grow" style="gap: 6px;">
        <vs-button :color="filter.local ? 'primary' : 'dark'" :type="filter.local ? 'filled' : 'border'"
                   class="p-2 cursor-pointer" @click="toggleLocal()">우리 지역</vs-button>

        <v-select style="width: 130px; margin: 0 4px" placeholder="분야 전체" label="name"
                  v-model="selectedFeed" :options="feeds" @input="reload()" />

        <v-select style="width: 120px; margin: 0 4px" placeholder="기사화 여부" label="name"
                  v-model="selectedUsed" :options="usedOptions" @input="reload()" />

        <vs-input placeholder="제목·요약 검색" v-model="filter.q" @keyup.enter="reload()" style="width: 200px" />
        <vs-button color="primary" type="border" class="p-2 cursor-pointer" @click="reload()">검색</vs-button>

        <span style="margin-left: 10px; font-size: 12px; color: #888;">
          {{ label }} · 총 {{ total }}건<span v-if="filter.local"> (지역)</span>
        </span>
      </div>

      <template slot="thead">
        <vs-th style="width: 90px">송고</vs-th>
        <vs-th style="width: 70px">분야</vs-th>
        <vs-th>제목</vs-th>
        <vs-th style="width: 80px">기자</vs-th>
        <vs-th style="width: 140px">작성자 · 기사 상태</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
               :class="{'wire-used': tr.used_article_id, 'wire-active': current && current.id === tr.id}">
          <vs-td><div @click="open(tr)">{{ shortTime(tr.published_at) }}</div></vs-td>
          <vs-td><div @click="open(tr)">{{ feedName(tr.category) }}</div></vs-td>
          <vs-td>
            <div @click="open(tr)" class="wire-title">
              <img v-if="tr.thumb_url" :src="tr.thumb_url" class="wire-thumb" loading="lazy" />
              <span v-if="tr.is_local" class="wire-badge">지역</span>{{ tr.title }}
            </div>
          </vs-td>
          <vs-td><div @click="open(tr)">{{ tr.writer }}</div></vs-td>
          <vs-td>
            <div @click="open(tr)" v-if="tr.used_article_id" :title="tr.used_at">
              <b>{{ tr.used_by_name || '작성됨' }}</b>
              <div class="wire-article-state">{{ articleState(tr) }}</div>
            </div>
            <div @click="open(tr)" v-else>-</div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-pagination :total="numOfPages" v-model="currentPage" v-if="numOfPages > 1"></vs-pagination>

    <!-- 미리보기: 행을 클릭하면 그때 본문을 가져온다(수집 때는 안 받는다) -->
    <vs-popup :title="current ? current.title : ''" :active.sync="popup" fullscreen>
      <div v-if="current" style="padding: 4px 8px 20px;">
        <div style="font-size: 12px; color: #777; margin-bottom: 10px;">
          {{ label }} · {{ feedName(current.category) }} · {{ current.writer }} · {{ current.published_at }}
          &nbsp;|&nbsp;
          <a :href="current.link" target="_blank" rel="noopener">원문 보기</a>
        </div>

        <div v-if="bodyLoading" style="padding: 30px 0; color: #888;">본문을 가져오는 중…</div>
        <div v-else-if="bodyError" style="padding: 20px 0; color: #c00;">
          본문을 가져오지 못했습니다 ({{ bodyError }}).
          <a :href="current.link" target="_blank" rel="noopener">원문에서 확인</a>
        </div>
        <!-- 사진은 본문 속 [[IMG:n]] 자리에 원문과 같은 순서로 들어간다.
             연합뉴스 원격 URL 을 그대로 띄운다(버킷에 복사하지 않는다) -->
        <div v-else class="wire-body" v-html="bodyHtml"></div>

        <div v-if="current.used_article_id" style="margin: 14px 0; color: #c60;">
          ⚠ 이미 기사로 작성된 건입니다({{ current.used_by_name || '작성자 미상' }},
          기사번호 {{ current.used_article_id }} · {{ articleState(current) }}).
        </div>

        <div style="margin-top: 20px; text-align: center;">
          <vs-button color="primary" class="p-3 cursor-pointer" @click="toWrite(current)">기사 작성</vs-button>
          <vs-button color="dark" type="border" class="p-3 cursor-pointer" style="margin-left: 10px;"
                     @click="popup = false">닫기</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: { 'v-select': vSelect },
  data() {
    return {
      label: '연합뉴스',
      list: [],
      feeds: [],
      total: 0,
      currentPage: 1,
      size: 30,
      filter: { local: false, q: '' },
      selectedFeed: null,
      selectedUsed: null,
      usedOptions: [
        { name: '전체', code: 'all' },
        { name: '미작성', code: 'unused' },
        { name: '작성됨', code: 'used' },
      ],
      current: null,
      popup: false,
      bodyLoading: false,
      bodyError: '',
      bodyHtml: '',
      images: [],
    };
  },
  computed: {
    numOfPages() { return Math.ceil(this.total / this.size) || 1; },
    activeUserInfo() { return this.$store.state.AppActiveUser; },
  },
  watch: {
    currentPage() { this.fetch(); },
  },
  created() { this.fetch(); },
  methods: {
    articleState(row) {
      if (!row.used_article_id) return '미작성';
      if (!Object.prototype.hasOwnProperty.call(row, 'linked_article_id')) return '상태 확인 필요';
      if (!row.linked_article_id) return '기사 없음';
      const states = { '-2': '삭제', '-1': '삭제', '0': '보류', '1': '출고', '2': '예약',
        '3': '편집완료', '4': '편집중', '8': '작성완료', '9': '작성중' };
      return states[String(row.used_article_state)] || '상태 확인 필요';
    },
    shortTime(s) {
      if (!s) return '';
      const d = new Date(s);
      if (isNaN(d.getTime())) return String(s).substring(5, 16);
      const p = function (n) { return (n < 10 ? '0' : '') + n; };
      return p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
    },
    feedName(slug) {
      const f = this.feeds.find(function (x) { return x.slug === slug; });
      return f ? f.name : slug;
    },
    toggleLocal() {
      this.filter.local = !this.filter.local;
      this.reload();
    },
    reload() { this.currentPage = 1; this.fetch(); },
    fetch() {
      const thisIns = this;
      this.$vs.loading({ scale: 1.2 });
      this.$http.post('/api/wire/list', {
        page: this.currentPage,
        size: this.size,
        local: this.filter.local ? 1 : 0,
        q: this.filter.q,
        category: this.selectedFeed ? this.selectedFeed.slug : '',
        used: this.selectedUsed ? this.selectedUsed.code : 'all',
      }).then(function (res) {
        thisIns.$vs.loading.close();
        thisIns.list = res.data.list || [];
        thisIns.total = res.data.total || 0;
        thisIns.feeds = res.data.feeds || [];
        thisIns.label = res.data.label || thisIns.label;
      }).catch(function () {
        thisIns.$vs.loading.close();
        thisIns.$vs.notify({ title: '오류', text: '수신함 목록을 불러오지 못했습니다.', color: 'danger' });
      });
    },
    // 🔴 여기서 처음으로 원문을 가져온다. 수집 때는 본문을 받지 않는다.
    open(row) {
      const thisIns = this;
      this.current = row;
      this.popup = true;
      this.bodyLoading = true;
      this.bodyError = '';
      this.bodyHtml = '';
      this.images = [];
      this.$http.post('/api/wire/get', { id: row.id }).then(function (res) {
        thisIns.bodyLoading = false;
        const d = res.data.data || {};
        thisIns.current = Object.assign({}, row, d);
        thisIns.bodyError = res.data.bodyError || '';
        // images 를 먼저 세팅해야 toHtml 이 [[IMG:n]] 을 풀 수 있다.
        thisIns.images = d.images || [];
        thisIns.bodyHtml = thisIns.toHtml(d.content || '');
        if (d.content) row.has_body = 1;
      }).catch(function () {
        thisIns.bodyLoading = false;
        thisIns.bodyError = '조회 실패';
      });
    },
    esc(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    // 본문의 [[IMG:n]] 을 그 자리에서 사진으로 바꾼다 — 원문과 같은 순서로 들어간다.
    toHtml(text) {
      const thisIns = this;
      return String(text || '').split('\n\n').map(function (p) {
        const m = p.trim().match(/^\[\[IMG:(\d+)\]\]$/);
        if (m) {
          const im = thisIns.images[Number(m[1])];
          if (!im) return '';
          return '<figure class="wire-fig"><img src="' + thisIns.esc(im.url) + '" loading="lazy">' +
                 (im.caption ? '<figcaption>' + thisIns.esc(im.caption) + '</figcaption>' : '') +
                 '</figure>';
        }
        return '<p>' + thisIns.esc(p).replace(/\n/g, '<br>') + '</p>';
      }).join('');
    },
    toWrite(row) {
      if (row.used_article_id &&
          !confirm('이미 기사로 작성된 건입니다. 새 기사로 또 작성할까요?')) return;
      this.$router.push({ path: '/writeArticles', query: { wire: row.id } });
    },
  },
};
</script>

<style>
#wire-list-view .wire-used { opacity: .55; }
#wire-list-view .wire-article-state { font-size: 12px; margin-top: 4px; white-space: nowrap; }
#wire-list-view .wire-active td { background: #f3f6ff; }
#wire-list-view .wire-badge {
  display: inline-block; margin-right: 6px; padding: 1px 6px; border-radius: 3px;
  background: #ea2121; color: #fff; font-size: 11px; vertical-align: middle;
}
#wire-list-view td > div { cursor: pointer; }
.wire-body { font-size: 15px; line-height: 1.75; max-width: 760px; margin: 0 auto; }
.wire-body p { margin: 0 0 14px; }
.wire-body .wire-fig { margin: 4px 0 18px; text-align: center; }
.wire-body .wire-fig img { max-width: 100%; height: auto; border-radius: 3px; }
.wire-body .wire-fig figcaption { margin-top: 6px; font-size: 12px; color: #777; text-align: left; }
#wire-list-view .wire-title { display: flex; align-items: center; gap: 6px; }
#wire-list-view .wire-thumb {
  width: 44px; height: 32px; object-fit: cover; border-radius: 2px; flex: none;
}
</style>
